import { DatePipe } from '@angular/common'
import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'ESTPipe',
})
export class ESTPipe implements PipeTransform {
  datePipe = new DatePipe('en-US')

  /*eslint complexity: ["error", 8]*/
  transform(value: string, notGMT = true): string {
    if (notGMT) {
      if (value) {
        return (
          // eslint-disable-next-line @typescript-eslint/no-magic-numbers
          value?.split('-')[1] +
          '/' +
          // eslint-disable-next-line @typescript-eslint/no-magic-numbers
          value?.split('-')[2].split('T')[0] +
          '/' +
          // eslint-disable-next-line @typescript-eslint/no-magic-numbers
          value?.split('-')[0]
        )
      } else {
        return null
      }
    } else {
      if (value && value.indexOf('GMT-4') > 0) {
        return value.replace('GMT-4', 'EDT')
      } else if (value && value.indexOf('GMT-5') > 0) {
        return value.replace('GMT-5', 'EST')
      }

      return value
    }
  }
}
